import { SharedPOSPage } from "./SharedPOSPage";
import { RESTAURANT_POS_CONFIG } from "./posConfig";

export const RestaurantPOSPage = () => (
  <SharedPOSPage config={RESTAURANT_POS_CONFIG} />
);
